import { create } from 'zustand'

export const useStore = create(() => ({
  pageNumberReconciliation: 1,
  pageNumberStatement: 1,
  pageNumberTransaction: 1,
}))

export const setReconciliationPageNumber: (pageNumber: number) => void = (pageNumber) => {
  useStore.setState((/*state:QueryOptionType*/) => {
    return ({ pageNumberReconciliation: pageNumber })
  })
}
export const setStatementPageNumber: (pageNumber: number) => void = (pageNumber) => {
  useStore.setState((/*state:QueryOptionType*/) => {
    return ({ pageNumberStatement: pageNumber })
  })
}
export const setTransactionPageNumber: (pageNumber: number) => void = (pageNumber) => {
  useStore.setState((/*state:QueryOptionType*/) => {
    return ({ pageNumberTransaction: pageNumber })
  })
}
